export const DEFAULT_OWNER_ONBOARDING_FIRST_NAME = 'Digidoo';
export const DEFAULT_OWNER_ONBOARDING_LAST_NAME = 'User';
export const USER_PROFILE_NAME_MAX_LENGTH = 100;
export const PASSWORD_MIN_LENGTH = 6;
export const PROVIDER_EMAIL = 'info@digidoo.com';
export const SUPPORT_USER_EMAIL = 'support@digidoo.com';
